import { nextTick, px } from "@front/utils";
import { createComponent } from "@front/utils/alpine";
import { Alpine } from "alpinejs";
import { debounce } from 'lodash-es';

function setMenuPosition (ctx: Alpine) {
    const top = ctx.$el.getBoundingClientRect().top + ctx.$el.clientHeight;
    ctx.$refs.wrapper.style.top = px(top);
    ctx.$refs.wrapper.style.height = `calc(100vh - ${px(top)})`;
}

function toggleBodyOverflow (force: boolean) {
    document.documentElement.classList.toggle('overflow-y-hidden', force);
}

export default createComponent(()=> ({
    isTouchDevice: () => window.matchMedia("(pointer: coarse)").matches,
    isOpened: false,
    openIndex: null as null | number,
    hoverTimeout: '',

    open () {
        this.isOpened = true;
        this.$dispatch('fractomenu:open');
        toggleBodyOverflow(true);
        nextTick(() => setMenuPosition(this));
    },

    close () {
        this.isOpened = false;
        this.$dispatch('fractomenu:close');
        toggleBodyOverflow(false);
    },

    init () {
        const ctx = this;

        nextTick(() => setMenuPosition(ctx));
        window.addEventListener('resize', debounce(() => setMenuPosition(ctx), 100));
    },

    isTouch (e) {
        if (window.matchMedia("(pointer: coarse)").matches) {
            e.preventDefault();
        }
    },

    underliner(e) {
        if(e.target.localName == "a" ){
            e.target.classList.add('text-gold','underline','underline-offset-4', 'decoration-gold');
        }
    }
}));
